import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as messageActions from '../../../modules/message'
import Flicking from "@egjs/react-flicking";
//import sc from 'styled-components';
import {nl2br, nl2brElement} from '../../../utils/utils'
import {APP_CONFIG} from '../../../utils/config'

import Privacy from '../../Privacy'


class SimpleGrid extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            currentPage : 0,
        }
    }
    
    /*
    componentDidUpdate(prevProps, prevState) {
        console.log("[componentDidUpdate]",this.carousel.getIndex())
        this.setState({
            currentPage : this.carousel.getIndex(),
        })
    }
    */

    clickMessage(value) {
       //console.log(this.props.message) 
        let sendData = {
            "utterance" : value, 
            "sessionKey" : this.props.message.sessionKey,
            "channelId" : this.props.message.channelId,
            "isLogin" : this.props.message.isLogin,
            "isDev" : this.props.config.isDev,
            "blockId" : "",
            "projectId" : this.props.config.projectId,
        }
        console.log(sendData)
        this.props.send(sendData);
    }

    clickPhoneNum(phoneNum){
        //console.log("calling : " + phoneNum);
        document.location.href = "tel:" + phoneNum;
    }

    clickProject(projectId) {
        const param = {
            projectId : projectId
        }
        this.props.get(param)
    }

    clickPageDot(index) {
        this.carousel.moveTo(index,500)
    }

    changePageDot() {
        //console.log(this.carousel.getIndex())
        this.setState({
            currentPage : this.carousel.getIndex(),
        })
    }

    render() {
        const cardStyle = {
            width: "unset",
            maxWidth: "100%"
        }

        const textStyle = {
            fontSize : "1.4rem",
            lineHeight : "1.3",
            letterSpacing : "-.4px",
            workBreak :"keep-all",
            whiteSpace : "normal"
        }

		/*
        const logoHelloStyle = {
            display:"block",
            backgroundImage:"url("+this.props.data.image.url+")",
			height:this.props.data.image.height+"px",
            backgroundSize:"contain",
            backgroundRepeat:"no-repeat",
            backgroundPositionX: "center",
            verticalAlign:"top",
            content:""
        }
		*/

        const getButton = (data,idx) => {
            const tabIndex = "0"
            if (data.action === 'webLink') {
                if (data.target) {
                    return  <a href={data.webLinkUrl} target={data.target} className="menu_link" tabIndex={tabIndex} key={idx}>
                                <span className="ico_comm" style={{backgroundImage:"url("+data.image.url+")"}}></span>
                                <div className="menu_unit">
                                    <span className="menu_txt">{nl2brElement(data.label)}</span>
                                </div>
                            </a>
                } else {
                    return  <a href={data.webLinkUrl} target={APP_CONFIG.popWinTarget} className="menu_link" tabIndex={tabIndex} key={idx}>
                                <span className="ico_comm" style={{backgroundImage:"url("+data.image.url+")"}}></span>
                                <div className="menu_unit">
                                    <span className="menu_txt">{nl2brElement(data.label)}</span>
                                </div>
                            </a>            
                }
            }
            if (data.action === 'message') {
                return  <a href="#none" className="menu_link" tabIndex={tabIndex} onClick={() => this.clickMessage(data.messageText)} key={idx}>
                            <span className="ico_comm" style={{backgroundImage:"url("+data.image.url+")"}}></span>
                            <div className="menu_unit">
                                <span className="menu_txt">{nl2brElement(data.label)}</span>
                            </div>
                        </a>
            }
            if (data.action === 'phone') {
                return  <a href="#none" className="menu_link" tabIndex={tabIndex} onClick={() => this.clickPhoneNum(data.phoneNumber)} key={idx}>
                            <span className="ico_comm" style={{backgroundImage:"url("+data.image.url+")"}}></span>
                            <div className="menu_unit">
                                <span className="menu_txt">{nl2brElement(data.label)}</span>
                            </div>
                        </a>
            }
            if (data.action === 'project') {
                return  <a href="#none" className="menu_link" tabIndex={tabIndex} onClick={() => this.clickProject(data.id)} key={idx}>
                            <span className="ico_comm" style={{backgroundImage:"url("+data.image.url+")"}}></span>
                            <div className="menu_unit">
                                <span className="menu_txt">{nl2brElement(data.label)}</span>
                            </div>
                        </a>
            }
        }
        
        const getItems = (startIdx, endIdx) => {
            let ret = this.props.data.buttons.map (
                (button, idx) => (
                    (idx >= startIdx && idx < endIdx)&& 
                    <li className="menu_item" key={idx}>{getButton(button, idx)}</li>
                )
            )
            return ret;
        }

        const setRows = this.props.data.buttonRow !== undefined ? this.props.data.buttonRow : 2
        const setColumns = 3
        const pagePerButtons = setColumns * setRows
        const buttonCnt = this.props.data.buttons.length
        const totalPages = Math.ceil(buttonCnt/setColumns/setRows)

        const getGrids = () => {
            /*
            const setRows = this.props.data.buttonRow !== undefined ? this.props.data.buttonRow : 2
            const setColumns = 3
            const pagePerButtons = setColumns * setRows
            const buttonCnt = this.props.data.buttons.length
            const totalPages = Math.ceil(buttonCnt/setColumns/setRows)
            */
    
            let startIdx = 0
            let endIdx = 0
            let ret = []
            for (let i = 0; i < totalPages; i++) {
                startIdx = i*pagePerButtons
                endIdx = pagePerButtons*(i+1)
                ret[i] = <ul className="menu_list" style={{width: "100%", display: "inline-block"}} key={i}>{getItems(startIdx, endIdx)}</ul>
            }
            return ret
        }

        let pagination = () => {
            let ret = [];

            //console.log(this.state.currentPage)

            for (let i =0; i < totalPages; i++) {
                if (this.state.currentPage === i) {
                    ret[i] = <li className="checked" key={i}></li>
                } else {
                    ret[i] = <li onClick={() => this.clickPageDot(i)} key={i}></li>
                }
            }
            return ret;
        }

        /*
        <div className="pagination">pagination
            <ul>
                <li className="checked"></li>
                <li></li>
            </ul>
        </div>
        */
	   /*
{ this.props.data.image !== undefined && this.props.data.image.url !== undefined && this.props.data.image.height !== undefined
                        && <span style={logoHelloStyle}/>
                }
	   */
		let alignStyle = {}
		let maxStyle = {}
		if (this.props.isGreeting) {
			alignStyle = {
				display: "flex",
				flexDirection: "column",
				alignItems: "flex-end"
			}

			maxStyle = {
				maxWidth : "550px"
			}
		} 
		
        return (
			<div className="bubble_box" style={maxStyle}>
            <div className="bubble_unit" style={alignStyle}>
				{ this.props.isGreeting && 
					<Privacy/>
				}
            <div className="card" style={cardStyle}>
                <div tabIndex={0} style={textStyle} dangerouslySetInnerHTML={{__html:nl2br(this.props.data.text)}}/>
                <div tabIndex={0} className="menu_link_title">자주 질문하는 정보</div>
                    <Flicking ref={carousel => {this.carousel = carousel}}
                        tag = "div"
                        viewportTag = "div"
                        cameraTag = "div"
                        classPrefix = "eg-flick"
                        deceleration = {0.0075}
                        horizontal = {true}
                        circular = {false}
                        infinite = {false}
                        infiniteThreshold = {0}
                        lastIndex = {Infinity}
                        threshold = {20}
                        duration = {500}
                        panelEffect = {x => 1 - Math.pow(1 - x, 3)}
                        defaultIndex = {0}
                        inputType = {["touch", "mouse"]}
                        thresholdAngle = {45}
                        bounce = {['10', '10']}
                        autoResize = {true}
                        adaptive = {false}
                        bound = {false}
                        overflow = {false}
                        hanger = {0}
                        anchor = {0}
                        gap = {5}
                        zIndex = {8}
                        moveType = {{type: "snap", count: 1}}
                        collectStatistics = {false}
                        onMoveEnd={() => this.changePageDot()}>
                            {getGrids()}
                    </Flicking>
                    <div className="pagination">
                        <ul>{pagination()}</ul>
                    </div>
            </div>
			</div>
			</div>
        );
    }
};

function mapStateToProps(state) {
    return {...state};
}

function mapDispatchToProps(dispatch) {
    return {
        send:(payload) => dispatch(messageActions.sendMessage(payload)),
        get:(payload) => dispatch(messageActions.getGreeting(payload))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SimpleGrid);

